import $axios from "@/plugins/axios-instance";

export default {
  state: {
    unreadCount: {
      unreadRequests: 0,
      unreadComments: 0
    },
    telegramLink: null
  },

  getters: {
    getUnreadCount(state) {
      return state.unreadCount;
    },
    hasUnreadRequestsOrComments(state) {
      return Object.values(state.unreadCount).some(item => item > 0);
    },
    getTelegramLink(state) {
      return state.telegramLink;
    }
  },
  mutations: {
    setUnreadCount(state, data) {
      state.unreadCount = data;
    },
    setTelegramLink(state, data) {
      state.telegramLink = data;
    }
  },
  actions: {
    fetchRequests(context, { skip, take }) {
      return $axios
        .get(`/userRequests?skip=${skip}&take=${take}`)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },
    fetchRequest(context, id) {
      return $axios
        .get(`/userRequests/${id}`)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },
    markAsRead({ dispatch }, id) {
      return $axios
        .post(`/userRequests/${id}/markAsRead`)
        .then(response => {
          dispatch("fetchUnreadRequests");
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },
    sendComment(context, data) {
      const { id, comment } = data;
      return $axios
        .post(`/userRequests/${id}/comment`, comment)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },
    changeStatus(context, data) {
      const { id, status } = data;
      return $axios
        .post(`/userRequests/${id}/changeStatus`, { status })
        .then(response => {
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },
    fetchUnreadRequests({ commit }) {
      return $axios
        .get(`/userRequests/unreadCount`)

        .then(response => {
          commit("setUnreadCount", response.data);
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    },
    fetchTelegramLink({ commit }) {
      return $axios
        .get(`/telegram`)

        .then(response => {
          commit("setTelegramLink", response.data);
          return response.data;
        })
        .catch(e => {
          throw e.response;
        });
    }
  }
};
